import "../components/Home/Home.css"
import { Divider } from 'antd'
import Banner from '../components/Home/Banner/Banner'
import Experience from '../components/Home/Experience/Experience'
import GlamStyle from '../components/Home/GlamStyle/GlamStyle'
import MagazinStyle from '../components/Home/MagazinStyle/MagazinStyle'
import Reviews from "../components/Home/Reviews/Reviews"

const Home = () => {
  return (
    <article>
        <Banner />
        <Experience />
        <MagazinStyle />
        <GlamStyle />
        <Divider style={{ borderWidth: '4px', borderColor: '#000', margin: '50px 0px'}} />
        <Reviews />
    </article>
  )
}

export default Home